import Skeleton from "react-loading-skeleton";

export function AnimatePriceLoading({
  children,
  isLoading = false,
  loaderWidth = 60,
}: {
  children: React.ReactNode;
  isLoading: boolean;
  loaderWidth?: number | string;
}) {
  if (isLoading) {
    return <Skeleton width={loaderWidth} />;
  }

  return <>{children}</>;
}
